'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

interface RotatingAwardsProps {
  className?: string;
  intervalMs?: number;
}

export function RotatingAwards({ className = '', intervalMs = 4000 }: RotatingAwardsProps) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIndex((p) => (p + 1) % 2), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return (
    <div className={`relative ${className}`}>
      <Image
        src="/netsuite-erp-award-laurel-600.png"
        alt="Netsuite ERP Award for OnePacific"
        quality={80}
        width={360}
        height={144}
        className={`block w-full transition-opacity duration-700 ${
          index === 0 ? 'opacity-80' : 'opacity-0'
        }`}
      />
      <Image
        src="/award2.png"
        alt="OnePac NetSuite Award"
        quality={80}
        width={600}
        height={211}
        className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-700 ${
          index === 1 ? 'opacity-80' : 'opacity-0'
        }`}
      />
    </div>
  );
}

export default RotatingAwards;
